document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('sticky-menu')) {
        class StickyMenu extends HTMLElement {
            constructor() {
                super();
                this._isOpen = true;
                this._isMobile = window.innerWidth < 768;
                this._isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;
                this._mobileOpen = false;

                this.innerHTML = `
                    
                    <!-- Desktop Menu -->
                    <div class="sticky-menu-container">
                        <i class="toggle-icon h-100 fa-light fa-angle-right text-light p-3 f-18 fw-4"></i>
                        <div class="menu-content">
                            <div class="product-navs w-100 d-flex align-items-center">
                                <a class="p-4 f-14 fw-4 text-decoration-none" href="/products/electric-guitars" data-link="electric-guitars">ELECTRIC GUITARS</a>
                                <a class="p-4 f-14 fw-4 text-decoration-none" href="/products/tremolo-bridge" data-link="tremolo-bridge">BRIDGES</a>
                                <a class="p-4 f-14 fw-4 text-decoration-none" href="/products/nut" data-link="nut">NUT</a>
                                <a class="p-4 f-14 fw-4 text-decoration-none" href="/products/neck" data-link="neck">NECK</a>
                                <a class="p-4 f-14 fw-4 text-decoration-none" href="/products/fx-cards-pedals" data-link="fx-cards-pedals">FX CARDS</a>
                                <a class="p-4 f-14 fw-4 text-decoration-none" href="/products/electronics" data-link="electronics">ELECTRONICS</a>
                                <a class="p-4 f-14 fw-4 text-decoration-none" href="/products/pickups" data-link="pickups">PICKUPS</a>
                                <a class="p-4 f-14 fw-4 text-decoration-none" href="/products/pickup-module" data-link="pickup-module">PICKUP MODULE</a>
                                <a class="ms-auto p-4 f-14 fw-4 text-decoration-none" href="/3d-designer" data-designer="1" style="background:#171717;color:var(--bs-primary);">LAUNCH 3D DESIGNER</a>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Mobile Menu (separate structure) -->
                    <div class="d-md-none">
                        <div class="mobile-menu">
                            <a class="f-14 fw-4" href="/3d-designer" data-designer="1" style="color:var(--bs-primary);">LAUNCH 3D DESIGNER</a>
                            <a class="f-14 fw-4" href="/products/pickup-module" data-link="pickup-module">PICKUP MODULE</a>
                            <a class="f-14 fw-4" href="/products/pickups" data-link="pickups">PICKUPS</a>
                            <a class="f-14 fw-4" href="/products/electronics" data-link="electronics">ELECTRONICS</a>                            
                            <a class="f-14 fw-4" href="/products/fx-cards-pedals" data-link="fx-cards-pedals">FX CARDS</a>
                            <a class="f-14 fw-4" href="/products/neck" data-link="neck">NECK</a>
                            <a class="f-14 fw-4" href="/products/nut" data-link="nut">NUT</a>
                            <a class="f-14 fw-4" href="/products/tremolo-bridge" data-link="tremolo-bridge">BRIDGES</a>
                            <a class="f-14 fw-4" href="/products/electric-guitars" data-link="electric-guitars">ELECTRIC GUITARS</a>
                        </div>
                        
                        <div class="mobile-bottom-bar">
                            <div class="mobile-toggle">
                                <i class="mobile-toggle-icon fa-thin fa-angle-left p-3 f-22 fw-normal"></i>
                            </div>
                            <div class="mobile-title f-16 fw-4 m-auto">PRODUCTS</div>
                        </div>
                    </div>
                `;
            }

            connectedCallback() {
                this._isMobile = window.innerWidth < 768;
                this._isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;

                if (this._isMobile) {
                    this._isOpen = false;
                }

                // Add listeners first so we can setup proper URLs
                this.addEventListeners();

                // Then update active link status
                this.updateActiveLink();

                // Finally update the menu state
                this.updateMenuState();
            }

            updateActiveLink() {
                const currentPath = window.location.pathname;
                const allLinks = [...this.querySelectorAll('.product-navs a'), ...this.querySelectorAll('.mobile-menu a')];

                allLinks.forEach(link => {
                    // Skip the 3D designer link
                    if (link.hasAttribute('data-designer')) {
                        return;
                    }

                    const dataLink = link.getAttribute('data-link');
                    if (dataLink && currentPath.includes(dataLink)) {
                        link.classList.add('active');
                    } else {
                        link.classList.remove('active');
                    }
                });
            }

            addEventListeners() {
                const desktopToggle = this.querySelector('.sticky-menu-container .toggle-icon');
                if (desktopToggle) {
                    desktopToggle.addEventListener('click', () => {
                        this._isOpen = !this._isOpen;
                        this.updateDesktopMenuState();
                    });
                }

                const mobileToggle = this.querySelector('.mobile-toggle');
                if (mobileToggle) {
                    mobileToggle.addEventListener('click', () => {
                        this._mobileOpen = !this._mobileOpen;
                        this.updateMobileMenuState();
                    });
                }

                // Add outside click listener to close mobile menu
                const handleOutsideClick = (event) => {
                    // Only handle clicks when in mobile mode and menu is open
                    if (!this._isMobile || !this._mobileOpen) {
                        return;
                    }

                    const mobileMenu = this.querySelector('.mobile-menu');
                    const mobileBottomBar = this.querySelector('.mobile-bottom-bar');

                    // Check if the click target is outside the mobile menu and bottom bar
                    if (mobileMenu && mobileBottomBar &&
                        !mobileMenu.contains(event.target) &&
                        !mobileBottomBar.contains(event.target)) {
                        this._mobileOpen = false;
                        this.updateMobileMenuState();
                    }
                };

                // Add listeners for both click and touchstart to handle mobile interactions
                document.addEventListener('click', handleOutsideClick);
                document.addEventListener('touchstart', handleOutsideClick);

                // Store reference to remove listeners if needed
                this._outsideClickHandler = handleOutsideClick;

                // Define language mappings
                const turkishLinks = {
                    'electric-guitars': 'elektro-gitar',
                    'tremolo-bridge': 'tremolo-kopru',
                    'nut': 'esik',
                    'neck': 'sap',
                    'fx-cards-pedals': 'fx-kartlari-pedallar',
                    'electronics': 'elektronikler',
                    'pickups': 'manyetikler',
                    'pickup-module': 'manyetik-modulu'
                };

                // Check if we're in Turkish mode and update hrefs accordingly
                const pathParts = window.location.pathname.split('/');
                const isInTurkish = pathParts[1] === 'tr';

                // Update all link hrefs based on current language
                const designerLinks = [...this.querySelectorAll('a[data-designer]')];
                designerLinks.forEach(link => {
                    link.setAttribute('href', isInTurkish ? '/tr/3d-tasarimci' : '/3d-designer');
                });

                const productLinks = [...this.querySelectorAll('a[data-link]')];
                productLinks.forEach(link => {
                    const dataLink = link.getAttribute('data-link');
                    if (!dataLink) return;

                    // Set the proper href based on current language
                    if (isInTurkish) {
                        const turkishLink = turkishLinks[dataLink] || dataLink;
                        link.setAttribute('href', `/tr/urunler/${turkishLink}`);
                    } else {
                        link.setAttribute('href', `/products/${dataLink}`);
                    }

                    // Add click handler
                    link.addEventListener('click', (event) => {
                        event.preventDefault();

                        // Get updated href (in case language changed)
                        const href = link.getAttribute('href');
                        if (href) {
                            window.location.href = href;
                        }
                    });
                });

                window.addEventListener('popstate', () => this.updateActiveLink());

                window.addEventListener('resize', () => {
                    const wasMobile = this._isMobile;
                    const wasTablet = this._isTablet;

                    this._isMobile = window.innerWidth < 768;
                    this._isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;

                    if (wasMobile !== this._isMobile) {
                        if (this._isMobile) {
                            this._isOpen = true;
                            this._mobileOpen = false;
                        } else {
                            this._isOpen = true;
                        }
                        this.updateMenuState();
                    }
                });
            }

            updateMenuState() {
                if (this._isMobile) {
                    this.updateMobileMenuState();
                } else {
                    this.updateDesktopMenuState();
                }
            }

            updateDesktopMenuState() {
                const menuContainer = this.querySelector('.sticky-menu-container');
                if (this._isOpen) {
                    menuContainer.classList.remove('closed');
                } else {
                    menuContainer.classList.add('closed');
                }
            }

            updateMobileMenuState() {
                const mobileMenu = this.querySelector('.mobile-menu');
                const mobileToggle = this.querySelector('.mobile-toggle');

                if (this._mobileOpen) {
                    mobileMenu.classList.add('open');
                    mobileToggle.classList.add('open');
                } else {
                    mobileMenu.classList.remove('open');
                    mobileToggle.classList.remove('open');
                }
            }

            // Clean up event listeners when element is removed
            disconnectedCallback() {
                if (this._outsideClickHandler) {
                    document.removeEventListener('click', this._outsideClickHandler);
                    document.removeEventListener('touchstart', this._outsideClickHandler);
                }
            }
        }

        window.customElements.define('sticky-menu', StickyMenu);

        if (!document.querySelector('sticky-menu')) {
            const stickyMenuElement = document.createElement('sticky-menu');
            document.body.appendChild(stickyMenuElement);
        }
    }
});